export const SUPPORTED_BROWSERS = {
  windows: {
    chrome: '>56.0',
    firefox: '>44.0',
    edge: '>79.0'
  },
  macos: {
    chrome: '>56.0',
    firefox: '>44.0',
    safari: '>12.1',
    edge: '>79.0'
  },
  linux: {
    chrome: '>56.0',
    firefox: '>44.0'
  },
  ios: {
    safari: '>12.1',
    chrome: '>89.0'
  },
  android: {
    chrome: '>65.0',
    firefox: '>68.0'
  }
}

export const BROWSER_METADATA = {
  edge: {
    installURL: 'https://www.microsoft.com/edge',
    vendor: 'Microsoft',
    browser: 'Edge'
  },
  chrome: {
    installURL: 'https://www.google.com/chrome/browser/',
    vendor: 'Google',
    browser: 'Chrome'
  },
  firefox: {
    installURL: 'https://www.mozilla.org/firefox/new/',
    vendor: 'Mozilla',
    browser: 'Firefox'
  },
  safari: {
    vendor: 'Apple',
    browser: 'Safari'
  }
}
